// Import this into scripts.js only if jQuery is absolutely needed
import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;

$(function () {
	$('.script-only').removeClass('hidden');
});
